const spots = [
  { icon: 'ri-mountain-2-line', name: '湯湾岳展望台', desc: '奄美でいちばん高い場所からの絶景' },
  { icon: 'ri-sailboat-line', name: 'タエン浜', desc: '透きとおった海でSUPや海水浴' },
  { icon: 'ri-compass-3-line', name: '屋鈍海岸', desc: 'たどり着いた人だけの、秘境ビーチ' },
  { icon: 'ri-map-pin-2-line', name: '宇検村', desc: '急いで通り過ぎるにはもったいない' },
];

export default function WhyUken() {
  return (
    <section className="bg-cream py-20 md:py-28 overflow-hidden">
      <div className="max-w-6xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-uken/10 text-uken text-xs font-rounded font-bold tracking-widest px-3 py-1.5 rounded-full mb-4">
            / WHY UKEN
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-rounded font-black text-kiln leading-tight">
            山へ、海へ。<br className="hidden md:block" />
            その前に、窯焼きの一枚。
          </h2>
        </div>

        {/* Full-width image */}
        <div className="relative w-full h-80 md:h-[480px] rounded-2xl overflow-hidden mb-14">
          <img
            src="https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/66c721869e3d934de136c51f2d7c20cd.webp"
            alt="車のボンネットの上にピザの箱 - 奄美の海と山"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-kiln/80 via-kiln/10 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-8">
            <p className="text-white font-rounded font-black text-xl md:text-2xl leading-relaxed">
              焼きたてのピザを持って、島をドライブ。<br className="hidden md:block" />
              景色のいい場所で開けたら、ふつうの一日がちょっと特別になります。
            </p>
          </div>
        </div>

        {/* Spots grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
          {spots.map((spot) => (
            <div key={spot.name} className="bg-white rounded-xl p-5 text-center">
              <div className="w-10 h-10 flex items-center justify-center bg-tankan/10 rounded-full mx-auto mb-3">
                <i className={`${spot.icon} text-tankan text-xl`} />
              </div>
              <p className="font-rounded font-black text-kiln text-sm">{spot.name}</p>
              <p className="font-rounded text-kiln/70 text-xs mt-1">{spot.desc}</p>
            </div>
          ))}
        </div>

        <p className="text-center text-kiln font-rounded text-sm">
          宇検村は急いで通り過ぎるにはもったいない場所。寄り道してください。
        </p>
      </div>
    </section>
  );
}
